/**
 * Application Version Configuration
 *
 * Versioning scheme: MAJOR.MINOR.PATCH
 * - MAJOR: 0 = beta, 1 = production ready
 * - MINOR: Feature set / release
 * - PATCH: Bug fixes, improvements
 *
 * Update this file before each deploy to master.
 */

export const VERSION = '0.8.0';

// Version history (for reference)
export const VERSION_HISTORY = [
  { version: '0.8.0', date: '2026-08-19', features: ['F100.1'], notes: 'Site analytics + admin shell, blog filters + search, newsletter signup, SleemAI coming soon, admin login lockout' },
  { version: '0.7.0', date: '2026-06-07', features: ['EP3'], notes: 'Hugo blog as the front door, build-in-public series' },
  { version: '0.6.0', date: '2026-02-11', features: ['F1b', 'F2d'], notes: 'Photo carousel in About section, Session persistence + Clear chat button' },
  { version: '0.5.0', date: '2026-02-10', features: ['F2.11'], notes: 'Resume generator with JSON edit & regenerate' },
  { version: '0.4.0', date: '2026-02-09', features: ['EP2', 'F2.1-F2.8'], notes: 'Resume generator (parser, analyzer, PDF builder, CLI, API, Admin UI)' },
  { version: '0.3.0', date: '2026-02-08', features: ['F1b'], notes: 'Enhanced About section (My Evolution, What I Bring boxes)' },
  { version: '0.2.0', date: '2026-02-02', features: ['F2f', 'F2h'], notes: 'Enhanced chatbot - System Prompt, Knowledge Architecture' },
  { version: '0.1.0', date: '2026-01-31', features: ['F1', 'F2', 'F2b', 'F2c', 'F6', 'F7'], notes: 'Initial beta - Landing, Chat, Security, RAG, Starters, Resume request' },
];
